module.exports = __webpack_public_path__ + "img/company.ae700a6b.png";